import { Box } from "@chakra-ui/react";
import React from "react";
import { DisplaySlate } from "../../utils/slate";
export const NotSelected = ({ text, scale, bgColor }) => {
    return (React.createElement(Box, { bgColor: bgColor },
        React.createElement(DisplaySlate, { text: text, scale: scale })));
};
